/**
 * Constants for mapping source_of_business key term values to Darwin lead source fields.
 * Only used for C21 Scheetz organization.
 */

/**
 * Maps source_of_business key term values to Darwin person_leadsource names.
 * The actual codeValueId is looked up dynamically from Darwin API.
 */
export const SOURCE_OF_BUSINESS_TO_DARWIN_LEAD_SOURCE_NAME: Record<
  string,
  string
> = {
  SOI: 'Sphere of Influence',
  Repeat: 'Repeat Customer',
  'Open House': 'Open House',
  'Sign Call': 'Yard Sign',
  'Floor Call': 'Call in Listing',
  'Personal Referral': 'Personal Referral',
  Relocation: 'Other Relocation Company',
  'Company Lead': 'Internet Lead',
  Other: 'Other',
};

/** Lead sources that should use "Office Generated" for leadGeneratedBy */
export const OFFICE_GENERATED_LEAD_SOURCES = ['Relocation', 'Company Lead'];

/** Darwin code value names for leadGeneratedBy */
export const LEAD_GENERATED_BY = {
  AGENT: 'Agent Generated',
  OFFICE: 'Office Generated',
} as const;

/**
 * Maps a source_of_business value to Darwin lead source and lead generated by names.
 * @param sourceOfBusiness - The source_of_business key term value
 * @returns Object with leadSource and leadGeneratedBy names, or null values if not mapped
 */
export const mapSourceOfBusinessToLeadSource = (
  sourceOfBusiness: string | undefined | null
): { leadSource: string | null; leadGeneratedBy: string | null } => {
  if (!sourceOfBusiness) {
    return { leadSource: null, leadGeneratedBy: null };
  }

  const leadSource =
    SOURCE_OF_BUSINESS_TO_DARWIN_LEAD_SOURCE_NAME[sourceOfBusiness] ?? null;

  if (!leadSource) {
    return { leadSource: null, leadGeneratedBy: null };
  }

  const leadGeneratedBy = OFFICE_GENERATED_LEAD_SOURCES.includes(
    sourceOfBusiness
  )
    ? LEAD_GENERATED_BY.OFFICE
    : LEAD_GENERATED_BY.AGENT;

  return { leadSource, leadGeneratedBy };
};
